export enum ETableLimit {
  MICRO = 'Micro',
  LOW = 'Low',
  MID = 'Mid',
  HIGH = 'High',
}
